/**
 * Formats a number of bytes into a human-readable string with units.
 * @param bytes The number of bytes.
 * @returns A formatted string representing the size in appropriate units.
 */
export function formatBytes(bytes: number) {
  if (!bytes) return "";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const idx = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, idx)).toFixed(1)} ${sizes[idx]}`;
}
